import { ActionButton } from "@fluentui/react"

export default function ChatButton() {
    return <ActionButton
        iconProps={{ iconName: "Chat" }}
        onClick={() => { window.open("https://t.me/beesexpress", "_blank") }}
    >Chat</ActionButton>
}